import React from 'react';
import { useAssessment } from '../context/AssessmentContext';
import Welcome from './screens/Welcome';
import HealingIntent from './screens/HealingIntent';
import SensitivityAssessment from './screens/SensitivityAssessment';
import HealingHistory from './screens/HealingHistory';
import FeaturePreferences from './screens/FeaturePreferences';
import InvestmentAssessment from './screens/InvestmentAssessment';
import CommunityPreferences from './screens/CommunityPreferences';
import Results from './screens/Results';
import CommunityOptIn from './screens/CommunityOptIn';
const AssessmentFlow: React.FC = () => {
  const {
    currentStep
  } = useAssessment();
  // Render the appropriate component based on the current step
  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return <Welcome data-id="element-21" />;
      case 1:
        return <HealingIntent data-id="element-22" />;
      case 2:
        return <SensitivityAssessment data-id="element-23" />;
      case 3:
        return <HealingHistory data-id="element-24" />;
      case 4:
        return <FeaturePreferences data-id="element-25" />;
      case 5:
        return <InvestmentAssessment data-id="element-26" />;
      case 6:
        return <CommunityPreferences data-id="element-27" />;
      case 7:
        return <Results data-id="element-28" />;
      case 8:
        return <CommunityOptIn data-id="element-29" />;
      default:
        return <Welcome data-id="element-30" />;
    }
  };
  return <div className="min-h-screen" data-id="element-31">{renderStep()}</div>;
};
export default AssessmentFlow;